import { easeOutCubic } from 'js-easing-functions';
import Textline from './_Textline.js';

export default class Index{
	constructor(){
		if(document.body.classList.contains("index")){
			window.addEventListener("siteready", this.prepare, {once:true})
			window.addEventListener("introDone", this.initialize, {once:true});
		}
	}
	prepare(){
		/*
		const delayscrolls = document.querySelectorAll(".delayscrollimg");
		delayscrolls.forEach(delayblock=>{
			const overrun = rpx(130);
			const img = delayblock.querySelector(".delayscrollimg__media");
			ScrollTrigger.create({
				trigger: delayblock,
				start: "top-=100% bottom",
				end: "bottom-=100% top",
				markers: true,
				onUpdate: data=>{
					const progress = easeOutCubic(data.progress, 0, 1, 1);
					console.log(progress);
					img.style.top = (rpx(130)*(1-progress)*-4)+"px";
				},
				markers: true
			});
		});
		*/

		const firstview = document.querySelector(".index__firstview");
		const firstview_main = document.querySelector(".index__firstview__main");
		gsap.fromTo(firstview_main, {
			y: 0,
		},{ 
			y: firstview.offsetHeight-firstview_main.offsetHeight,
			ease: "none",
			scrollTrigger: { 
				trigger: firstview,
				start: "top top",
				end: "bottom top",
				scrub: true,
				invalidateOnRefresh: true
			}
		});
		const firstview_mainslideshow = firstview.querySelectorAll(".index__firstview__img1, .index__firstview__img2");
		const firstview_subslideshow = firstview.querySelectorAll(".index__firstview__img3, .index__firstview__img4");
		if(window.currentContext == "pc"){
			firstview_mainslideshow.forEach(slideshow=>{
				const viewport = slideshow.querySelector(".index__firstview__slideimages__viewport");
				gsap.fromTo(viewport, {
					yPercent: -20,
				},{ 
					yPercent: 20,
					ease: "none",
					scrollTrigger: { 
						trigger: slideshow,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						invalidateOnRefresh: true
					}
				});
			});
			firstview_subslideshow.forEach(slideshow=>{
				const viewport = slideshow.querySelector(".index__firstview__slideimages__viewport");
				gsap.fromTo(viewport, {
					yPercent: 0,
				},{ 
					yPercent: -33.3333,
					ease: "none",
					scrollTrigger: { 
						trigger: slideshow,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						invalidateOnRefresh: true
					}
				});
			});
		}else{
			// firstview_mainslideshow.forEach(slideshow=>{
			// 	const viewport = slideshow.querySelector(".index__firstview__slideimages__viewport");
			// 	gsap.fromTo(viewport, {
			// 		yPercent: 0,
			// 	},{ 
			// 		yPercent: 20,
			// 		ease: "none",
			// 		scrollTrigger: { 
			// 			trigger: firstview_main,
			// 			start: "top top",
			// 			end: "bottom top",
			// 			scrub: true,
			// 			invalidateOnRefresh: true
			// 		}
			// 	});
			// });
			firstview_subslideshow.forEach(slideshow=>{
				const viewport = slideshow.querySelector(".index__firstview__slideimages__viewport");
				gsap.fromTo(viewport, {
					yPercent: 0,
				},{ 
					yPercent: 33.3333,
					ease: "none",
					scrollTrigger: { 
						trigger: slideshow,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						invalidateOnRefresh: true
					}
				});
			});
		}


		const introduction = document.querySelector(".index__introduction");
		const introductionMain = document.querySelector(".index__introduction__main");
		const introductionBg = document.querySelector(".index__introduction__main__bg");
		const introductionBgAxis1 = introduction.querySelector(".index__introduction__main__bg__axis1");
		const introductionBgAxis2 = introduction.querySelector(".index__introduction__main__bg__axis2");
		const introductionBody = document.querySelector(".index__introduction__main__body");
		const introLineset = window.currentContext=="pc" ? document.querySelectorAll(".index__introduction__main__body__vertical__lead .textline, .index__introduction__main__body__vertical__text.pctext .textline") : document.querySelectorAll(".index__introduction__main__body__vertical__lead .textline, .index__introduction__main__body__vertical__text.sptext .textline");
		const introTextline = new Textline(introLineset);
		gsap.fromTo(introductionBgAxis1, {
			yPercent: -50,
		},{ 
			yPercent: 0,
			ease: "none",
			scrollTrigger: { 
				trigger: introductionMain,
				start: ()=>"top bottom",
				end: ()=>"top+="+window.lvh+" bottom",
				scrub: true,
				invalidateOnRefresh: true
			}
		});
		gsap.fromTo(introductionBgAxis2, {
			yPercent: 0,
		},{ 
			yPercent: 50,
			ease: "none",
			scrollTrigger: { 
				trigger: introductionMain,
				start: ()=>"bottom bottom",
				end: ()=>"bottom+="+window.lvh+" bottom",
				scrub: true,
				invalidateOnRefresh: true
			}
		});
		ScrollTrigger.create({
			trigger: introductionBg,
			start: "top top",
			endTrigger: introductionMain,
			end: "bottom bottom",
			pin: true,
			pinSpacing: true
		});
		ScrollTrigger.create({
			trigger: introductionBody,
			start: ()=>"center+="+(window.currentContext=="pc" ? rpx(60) : rpx(40))+" center",
			endTrigger: introductionMain,
			end: ()=>"bottom-="+(window.lvh/2)+"px center",
			pin: true,
			onUpdate: self=>introTextline.textProgress(self.progress)
		});
	}

	initialize(){
		const firstview = document.querySelector(".index__firstview");
		const progress = firstview.querySelector(".index__firstview__main__progress");
		const progress_meter = firstview.querySelector(".index__firstview__main__progress__bar__meter");
		const progress_num = firstview.querySelector(".index__firstview__main__progress__pager__current");
		const slideMax = Array.from(firstview.querySelectorAll(".index__firstview__img1 .index__firstview__slideimages__slide"))?.length || 0;
		const firstviewSlideDuration = 6000;
		const rewindDuration = 500;
		let slidePosition = 0;

		const changeSlide = ()=>{
			firstview.classList.remove("nomask");
			requestAnimationFrame(()=>{requestAnimationFrame(()=>{
				firstview.setAttribute("data-lastposition", slidePosition);
				slidePosition = (slideMax > slidePosition) ? slidePosition+1 : 1;
				firstview.setAttribute("data-position", slidePosition);
				progress_meter.classList.add("rewind");
				progress_num.innerHTML = String(2-(slidePosition%2)).padStart(2, '0');
				setTimeout(()=>{
					progress_meter.classList.remove("rewind");
				}, 500);
				setTimeout(()=>{
					firstview.classList.add("nomask");
				},2000);
			})})
		}
		setTimeout(()=>{
			progress_meter.classList.add("progress");
			progress_meter.style.transitionDuration = ((firstviewSlideDuration - rewindDuration)/1000)+"s";
			setInterval(changeSlide, firstviewSlideDuration);
			changeSlide();
		}, 250);
	}
}